import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { COMMON_IMPORTS } from '@easihub/ngx';
import { AppFooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { AppPrimarySidebarComponent } from './sidebar/primary-sidebar.component';
import { SplashComponent } from './splash/splash.component';

@Component({
  selector: 'easihub-web-app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [
    COMMON_IMPORTS,
    RouterModule,
    MatSidenavModule,
    AppFooterComponent,
    HeaderComponent,
    AppPrimarySidebarComponent,
    SplashComponent,
  ],
  host: {
    'class': 'flex flex-col min-h-screen'
  }
})
export class AppComponent { }
